<template>
    <div>
        <a-form-model ref="groupOptionsForm"
                        :model="groupOptionsModel"
                        :rules="groupOptionsRules"
        >
            <!-- Group Option Basic Information -->
            <a-row :gutter="[24]">
                <a-col :span="4">
					<a-form-model-item class="mb-10" 
                                        label="Code Name" 
                                        :colon="false"
                                        ref="codeName"
                                        prop="codeName"
                    >
						<a-input v-model="groupOptionsModel.codeName" 
                                placeholder="01"
                                :maxLength="2"
                                @blur="() => { $refs.codeName.onFieldBlur() }"  
                        />
					    </a-form-model-item>
				</a-col>
                <a-col :span="8">
					<a-form-model-item class="mb-10" 
                                        label="Main Description" 
                                        :colon="false"
                                        ref="description"
                                        prop="description"
                    >
						<a-input v-model="groupOptionsModel.description" 
                                placeholder="eg. Minimal Bar Stool"
                                @blur="() => { $refs.description.onFieldBlur() }"  
                        />
					    </a-form-model-item>
				</a-col>
                <a-col :span="4">
					<a-form-model-item class="mb-10" 
                                        label="Max Selection" 
                                        :colon="false"
                                        ref="maxSelection"
                                        prop="maxSelection"
                    >
						<a-input-number v-model="groupOptionsModel.maxSelection" 
                                        :min="1" 
                                        :max="10"
                                        @blur="() => { $refs.maxSelection.onFieldBlur() }"  
                        />
					</a-form-model-item>
				</a-col>
                <a-col :span="8">
					<a-form-model-item class="mb-10" 
                                        label="Price Type" 
                                        :colon="false"
                                        ref="priceType"
                                        prop="priceType"
                    >
						<a-select v-model="groupOptionsModel.priceType">
                            <a-select-option v-for="(p,index) in priceTypes" :key="index" :value="p.value">
                                {{ p.description }}
                            </a-select-option>
                        </a-select>
					</a-form-model-item>
				</a-col>
            </a-row>
            <!-- / Group Option Basic Information -->

            <!-- Options -->
            <a-row :gutter="[24]">
                <a-col :span="24">         
                    <a-button class="editable-add-btn" @click="handleAddNewOption">
                        Add New Option
                    </a-button>
                    <a-popconfirm title="Are you sure to delete the whole group option?"
                                ok-tex="Yes"
                                cancel-text="No"
                                @confirm="handleDeleteOption"
                    >
                        <a-button type="danger" class="ml-10">
                            Delete
                        </a-button>
                    </a-popconfirm>
                    
                    <a-table :columns="cols"
                                :data-source="groupOptionsModel.options"
                                rowKey="index"
                                bordered
                                size="small"
                    >
                        <template slot="index" slot-scope="text, record, index">
                            <p>{{ index + 1 }}</p>
                        </template>

                        <template v-for="col in ['description', 'shortName', 'price']"
                                    :slot="col"
                                    slot-scope="text, record, index"
                        > 
                            <div :key="col">
                                <a-input v-if="record.editable"
                                        style="margin: -5px 0"
                                        :value="text"
                                        allow-clear
                                        @change="e => handleChange(e.target.value, record.index, col)" 
                                />
                                <template v-else>
                                    {{ text }}
                                </template>
                             </div>   
                        </template>

                        <template slot="operations" slot-scope="record">
                            <div class="editable-row-operations">
                                <span v-if="record.editable">
                                    <a @click="() => save(record.index)">Save</a>
                                    <a-popconfirm title="Sure to cancel?" @confirm="() => cancel(record.index)">
                                        <a>Cancel</a>
                                    </a-popconfirm>
                                </span>
                                <span v-else>
                                    <a :disabled="editingKey !== ''" @click="() => edit(record.index)">Edit</a>
                                </span>
                            </div>
			            </template>

                        <template slot="delete" slot-scope="record">
                            <div class="editable-row-operations"> 
                                <span>
                                    <a-popconfirm title="Sure to delete?" @confirm="() => handleDelete(record.index)">
                                        <a :disabled="editingKey !== ''">Delete</a>
                                    </a-popconfirm>
                                </span>
                            </div>
                        </template>
                    </a-table>
				</a-col>
            </a-row>
            <!-- / Options -->
        </a-form-model>
    </div>
</template>

<script>

const cols = [
    {
		title: '#',
		dataIndex: 'index',
        key: 'index',
        scopedSlots: { customRender: 'index' },
	},
    {
        title : 'description',
        dataIndex: 'description',
        key : 'description',
        scopedSlots: { customRender: 'description' },
    },
    {
		title: 'short name', //code name
		dataIndex: 'shortName',
        key: 'shortName',
        scopedSlots: { customRender: 'shortName' },
	},
    {
        title : 'price',
        dataIndex: 'price',
        key : 'price',
        scopedSlots: { customRender: 'price' },
    },
    {
		title : 'operations',
		scopedSlots : { customRender: 'operations'},
		fixed: 'right'
	},
    {
		title : 'delete',
		scopedSlots : { customRender: 'delete'},
		fixed: 'right'
	}
];

export default {

    data () {
        return {
            cols,
            editingKey : '',
            cacheData : [],
            maxRows : 10,
            priceTypes : [
                {
                    description: 'Added Price',
                    value : 0
                },
                {
                    description: 'Max price',
                    value : 1
                }
            ],
            groupOptionsRules : {
                description : [
                    {
                        required: true,
                        message : 'The field shoud not be blank',
                        trigger:blur
                    },
                    {
                        min:3,
                        message : 'The field should be at least 3 characters',
                        trigger:blur
                    }
                ],
            },

            groupOptionsModel : {
                codeName : null, 
                description : null,
                maxSelection : 1,
                priceType : 0,
                options : [
                    // {
                    //     index : 0,
                    //     description : '19B. Softshell Crabbe Maki',
                    //     price : 399.00,
                    //     shortName : '19B'
                    // },
                    // {
                    //     index : 1,
                    //     description : '19C. Crispy Chicken Maki',
                    //     price : 389.00,
                    //     shortName : '19C'
                    // }
                ]
            },
        }
    },

    methods : {

        getGroupOptions() {
            let payload = this.$lodash.cloneDeep(this.groupOptionsModel);
            this.reset();
            return payload;
        },

        setGroupOptions(payload) {
            this.groupOptionsModel = this.$lodash.cloneDeep(payload);
        },

        reset() {
            this.groupOptionsModel = {
                description : '',
                maxSelection : 1,
                priceType : 0,
                options : []
           }
        }, 

        handleBtnDelete(record) {
            this.groupOptionsModel.options.splice(record.index,1);
			//
			//reassign index
			//
			for(let i = 0; i < this.groupOptionsModel.options.length; i++) {
				this.groupOptionsModel.options[i].index = i;
			}
        },
        handleAddNewOption() {
            if (this.groupOptionsModel.options.length <= this.maxRows) {
                let arrayindex = this.groupOptionsModel.options.length;
                let option = {
                    index : arrayindex,
                    description : 'New Option ' + arrayindex,
                    price : 0.0
                }
                this.groupOptionsModel.options.push(option);
            }
        },

        handleDeleteOption() {
            this.$emit('deleteGroupOptionEvent', {});
        },

        //
        //Handle edit, save table row
        //
        handleChange(value, key, column) {
            //console.log('handleChange');
            const newData = [...this.groupOptionsModel.options];
            //console.log(key)
            const target = newData.find(item => key == item.index);
            //console.log(target)
            if (target) {
                target[column] = value;
                //console.log(target)
                this.groupOptionsModel.options = newData;
            }
        },

        edit (key) {
            const newData = [...this.groupOptionsModel.options];
            const target = newData.find(item => key == item.index);
            this.editingKey = key;
            if (target) {
                target.editable = true;
                this.groupOptionsModel.options = newData;
            }
        },

        save (key) {
            this.cacheData = this.groupOptionsModel.options.map(item => ({ ...item }));
            const newData = [...this.groupOptionsModel.options];
            const newCacheData = [...this.cacheData];
            const target = newData.find(item => key === item.index);
            const targetCache = newCacheData.find(item => key === item.index);

            if(target && targetCache) {
                delete target.editable;
                this.groupOptionsModel.options = newData;
                Object.assign(targetCache, target);
                this.cacheData = newCacheData;
            }
            console.log(newData)
            this.editingKey = '';
        },

        cancel (key) {
            this.cacheData = this.groupOptionsModel.options.map(item => ({ ...item }));
            const newData = [...this.groupOptionsModel.options];
            const target = newData.find(item => key === item.index);
            this.editingKey = '';
            if(target) {
                Object.assign(target, this.cacheData.find(item => key === item.index));
                delete target.editable;
                this.groupOptionsModel.options = newData;
            }
        },

        handleDelete (key) {
            this.groupOptionsModel.options.splice(key,1);
			//
			//reassign index
			//
			for(let i = 0; i < this.groupOptionsModel.options.length; i++) {
				this.groupOptionsModel.options[i].index = i;
			}
        },        
    },
}
</script>

<style>
    .editable-row-operations a {
        margin-right: 8px;
    }
</style>